// src/components/Notification.js
import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

function Notification({ message, type = "success", onClose }) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose(); // auto-hide after 3s
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
          className={`alert alert-${type} mt-3`}
          role="alert"
        >
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Notification;
